"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldLabel = exports.FieldLabelDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var form_field_id_1 = require("../../utils/form-field-id");
var use_lang_1 = require("../../hooks/use-lang");
var field_description_1 = require("./field-description");
var icon_1 = require("../elements/icon");
var icons_1 = require("../icons");
var ExclamationCircle = icons_1.Icons.ExclamationCircle;
var loader_1 = require("../elements/loader");
var html_1 = require("../elements/html");
var badge_1 = require("../elements/badge");
exports.FieldLabelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    line-height: 1em;\n    \n    b {\n      color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    line-height: 1em;\n    \n    b {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('text'), theme_1.theme.COLOR('primary')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var FieldDescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-size: 13px;\n    color: ", ";\n    align-items: center;\n  "], ["\n    text-transform: uppercase;\n    font-size: 13px;\n    color: ", ";\n    align-items: center;\n  "])), theme_1.theme.COLOR('text-subtle')),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    align-items: center; \n  "], ["\n    align-items: center; \n  "])))
});
var LabelAndLoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    width: 16px;\n    height: 16px;\n    margin-right: ", ";\n\n  "], ["\n    ", ";\n    width: 16px;\n    height: 16px;\n    margin-right: ", ";\n\n  "])), theme_1.theme.FILL('error'), theme_1.theme.UNIT(2))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.label(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  FieldDescription: (0, styled_components_1.default)(field_description_1.FieldDescription)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FieldDescriptionStyles),
  LabelAndLoader: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelAndLoaderStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
var FieldLabel = function (props) {
  var className = props.className,
    field = props.field;
  var t = (0, use_lang_1.useLang)();
  if (!field) {
    return null;
  }
  var label = field.label,
    description = field.description,
    required = field.required,
    recommended = field.recommended,
    loadingMessage = field.loadingMessage,
    disabled = field.disabled;
  var valid = field.valid === undefined ? true : !!field.valid;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.LabelAndLoader, null, React.createElement(My.Label, {
    htmlFor: (0, form_field_id_1.formFieldId)(field)
  }, !valid && React.createElement(My.Icon, null, React.createElement(ExclamationCircle, null)), t(label), required && React.createElement(My.Badge, null, t('Required')), field.badge && React.createElement(My.Badge, null, field.badge), !required && recommended && !disabled && React.createElement(My.Badge, {
    isPending: true
  }, t('Recommended'))), loadingMessage && React.createElement(My.Loader, {
    spaceUnits: 1.5
  }, t(loadingMessage))), !disabled && description && React.createElement(My.FieldDescription, {
    field: field
  }, React.createElement(html_1.HTML, {
    text: t(description),
    allowedTags: ['br', 'strong', 'b', 'em', 'i']
  })));
};
exports.FieldLabel = FieldLabel;
exports.FieldLabel.defaultProps = exports.FieldLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;